/**
 * Short display name for the CDS user menu from account status profile.
 * @param {object|null|undefined} accountStatus - Account status `data` from API.
 * @returns {string|null}
 */
export default function getCdsFpDisplayName(accountStatus) {
  const fullName = accountStatus?.full_name?.trim();
  if (!fullName) return null;

  const parts = fullName.split(/\s+/).filter(Boolean);
  if (parts.length === 0) return null;
  if (parts.length === 1) return parts[0];

  return `${parts[0]} ${parts[1].charAt(0)}.`;
}
